"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccordion = exports.getAccordionSelection = exports.AccordionSelectionType = void 0;
var lodash_1 = require("lodash");
var slate_1 = require("slate");
var AccordionSelectionType;
(function (AccordionSelectionType) {
    AccordionSelectionType["None"] = "None";
    AccordionSelectionType["Around"] = "Around";
    AccordionSelectionType["Inside"] = "Inside";
    AccordionSelectionType["Full"] = "Full";
})(AccordionSelectionType = exports.AccordionSelectionType || (exports.AccordionSelectionType = {}));
var getAccordionDummyPoint = function (accordionPath) {
    return {
        path: __spreadArray(__spreadArray([], __read(accordionPath), false), [0, 0], false),
        offset: 0,
    };
};
var getAccordionSelection = function (editor, accordionPath) {
    var selection = editor.selection;
    if (!selection) {
        return AccordionSelectionType.None;
    }
    var selectionInDummy = slate_1.Range.isCollapsed(selection) && slate_1.Point.equals(selection.anchor, getAccordionDummyPoint(accordionPath));
    if (selectionInDummy) {
        return AccordionSelectionType.Full;
    }
    var getAccordionChildNodePath = function (point) { return (0, lodash_1.take)(point.path, accordionPath.length + 1); };
    var anchorWithinAccordion = slate_1.Path.isDescendant(selection.anchor.path, accordionPath);
    var selectionWithinOneContentArea = (0, lodash_1.isEqual)(getAccordionChildNodePath(selection.anchor), getAccordionChildNodePath(selection.focus));
    if (anchorWithinAccordion && selectionWithinOneContentArea) {
        return AccordionSelectionType.Inside;
    }
    var accordionBoundaries = slate_1.Editor.range(editor, accordionPath);
    var accordionBoundaryInSelection = slate_1.Range.includes(selection, accordionBoundaries.anchor) || slate_1.Range.includes(selection, accordionBoundaries.focus);
    if (slate_1.Range.isExpanded(selection) && accordionBoundaryInSelection) {
        return AccordionSelectionType.Around;
    }
    return AccordionSelectionType.None;
};
exports.getAccordionSelection = getAccordionSelection;
var selectAccordion = function (editor, accordionPath) {
    var dummyPoint = getAccordionDummyPoint(accordionPath);
    slate_1.Transforms.select(editor, dummyPoint);
};
exports.selectAccordion = selectAccordion;
